import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { NotificationCenterComponent } from '../notification-center/notification-center.component'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-layout-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class LayoutMenuComponent {
  realm: any;
  model: any = {};
  @Input() user;
  @Output() verify = new EventEmitter();
  menu: Array<any> = [];
  badgeActive: boolean = false;
  private intervalId: any;
  constructor(private keycloak: KeycloakService, private route: ActivatedRoute, private translate: TranslateService, private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.model = {
      partner: '',
      account: '',
      merchant: ''
    };

    this.route.paramMap.subscribe(params => {
      this.model.partner = params.get('partner') || undefined;
      this.model.account = params.get('account') || undefined;
      this.model.merchant = params.get('merchant') || undefined;
    });

    console.log("partner:", this.model.partner, "account:", this.model.account, "merchant:", this.model.merchant);

    this.realm = this.keycloak.getKeycloakInstance().realm;

    if (this.user.features.find(p => p.key == "connections")?.enabled) {
      this.menu = this.user.features.filter(p => p.key != "services")
    } else {
      this.menu = this.user.features.filter(p => p.key != "connections");
    }

    this.startAutoUpdate();
    this.checkBadgeStatus();
  }

  checkBadgeStatus() {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];

    this.badgeActive = notifications.some((notification: any) => notification.read === false && !notification.hidden);
  }

  startAutoUpdate() {
    this.intervalId = setInterval(() => {
      this.checkBadgeStatus();
    // }, 500000);
    }, 5000);
  }

  verifyMenu() {
    this.verify.emit();;
  }

  openNotificationCenter() {
    this.startAutoUpdate();
    this.dialog.open(NotificationCenterComponent, {
      maxWidth: '700px',
      width: '100%',
      autoFocus: false,
      data: {
        partner: this.model.partner,
        account: this.model.account,
        merchant: this.model.merchant,
      },
    });
  }
}
